import React from 'react';
import Icon from '../../../components/AppIcon';

const MinimapOverview = ({ floorPlanData, currentView, onNavigate }) => {
  const handleSectionClick = (section) => {
    onNavigate(section);
  };

  return (
    <div className="bg-card rounded-xl shadow-lg p-4 md:p-6">
      {/* Header */}
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center">
          <Icon name="Map" size={20} color="var(--color-primary)" />
        </div>
        <h3 className="text-base md:text-lg font-semibold">Vista General</h3>
      </div>
      {/* Minimap */}
      <div className="relative bg-muted/30 rounded-xl overflow-hidden mb-4" style={{ aspectRatio: '4/3' }}>
        <svg
          className="w-full h-full"
          viewBox="0 0 400 300"
          preserveAspectRatio="xMidYMid meet"
        >
          {/* Sections */}
          {floorPlanData?.sections?.map((section) => (
            <g key={section?.id}>
              <rect
                x={section?.x}
                y={section?.y}
                width={section?.width}
                height={section?.height}
                className={`cursor-pointer transition-smooth ${
                  currentView === section?.id
                    ? 'fill-primary/40 stroke-primary' :'fill-muted/50 stroke-border hover:fill-primary/20'
                }`}
                strokeWidth="2"
                onClick={() => handleSectionClick(section)}
              />
              <text
                x={section?.x + section?.width / 2}
                y={section?.y + section?.height / 2}
                textAnchor="middle"
                dominantBaseline="middle"
                className="text-xs font-medium fill-foreground pointer-events-none"
              >
                {section?.name}
              </text>
            </g>
          ))}
        </svg>

        {/* Current View Indicator */}
        <div className="absolute top-2 right-2 bg-primary text-primary-foreground px-2 py-1 rounded text-xs font-medium">
          Vista actual
        </div>
      </div>
      {/* Quick Navigation */}
      <div className="space-y-2">
        <h4 className="text-sm font-medium mb-3">Navegación rápida</h4>
        {floorPlanData?.sections?.map((section) => (
          <button
            key={section?.id}
            onClick={() => handleSectionClick(section)}
            className={`w-full flex items-center justify-between p-3 rounded-xl transition-smooth touch-target focus-ring ${
              currentView === section?.id
                ? 'bg-primary text-primary-foreground'
                : 'bg-muted/50 hover:bg-muted'
            }`}
          >
            <div className="flex items-center gap-3">
              <Icon name="MapPin" size={18} />
              <span className="text-sm font-medium">{section?.name}</span>
            </div>
            <span className="text-xs opacity-80">{section?.lotCount} lotes</span>
          </button>
        ))}
      </div>
      {/* Legend */}
      <div className="mt-6 pt-4 border-t border-border">
        <h4 className="text-sm font-medium mb-3">Leyenda</h4>
        <div className="space-y-2">
          <div className="flex items-center gap-3">
            <div className="w-4 h-4 rounded bg-success/40 border-2 border-success"></div>
            <span className="text-xs md:text-sm">Disponible</span>
          </div>
          <div className="flex items-center gap-3">
            <div className="w-4 h-4 rounded bg-warning/40 border-2 border-warning"></div>
            <span className="text-xs md:text-sm">Reservado</span>
          </div>
          <div className="flex items-center gap-3">
            <div className="w-4 h-4 rounded bg-error/40 border-2 border-error"></div>
            <span className="text-xs md:text-sm">Vendido</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MinimapOverview;